import { SubmissionError } from 'redux-form';
import { replace } from 'react-router-redux';

import { getGoogleAnalyticsClientId } from '../../utils/tracking/googleAnalytics';
import clientIdCustom from '../../utils/tracking/clientIdCustom';
import { CardTypes } from '../../utils/enums';
import apiSubscribeEmail from '../../utils/widget/subscribeApi';
import getGeoIpData from '../../utils/localRepresentative/geoip-service';
import { trackWidgetVisible } from '../../utils/facebookPixel';
import { onWidgetVisibleSalon, onEngagement } from '../../utils/tracking/salonTracking';
import { SENTIMENT_POLL_ANSWERED } from '../SentimentPoll/actions';

export const SET_END_USER_ID = 'SET_END_USER_ID';
export const SET_END_USER_LOCATION = 'SET_END_USER_LOCATION';
export const ACTION_SHARED = 'ACTION_SHARED';
export const OVERLAY_VISIBLE = 'OVERLAY_VISIBLE';
export const OVERLAY_PUBLISHER_VISIBLE = 'OVERLAY_PUBLISHER_VISIBLE';
export const OVERLAY_PARTNER_VISIBLE = 'OVERLAY_PARTNER_VISIBLE';
export const OVERLAY_ELECTION_VISIBLE = 'OVERLAY_ELECTION_VISIBLE';
export const WIDGET_VISIBLE = 'WIDGET_VISIBLE';
export const WIDGET_ENGAGED = 'WIDGET_ENGAGED';
export const WIDGET_RESIZED = 'WIDGET_RESIZED';
export const ACTION_VISIBLE = 'ACTION_VISIBLE';
export const GO_NEXT_ACTION = 'GO_NEXT_ACTION';
export const SET_ACTIVE_ACTION = 'SET_ACTIVE_ACTION';
export const HIDE_NEXT_ACTION_ANIMATION = 'HIDE_NEXT_ACTION_ANIMATION';
export const SHOW_NEXT_ACTION_ANIMATION = 'SHOW_NEXT_ACTION_ANIMATION';
export const ON_BACK_FROM_REP_ACTION = 'ON_BACK_FROM_REP_ACTION';
export const ACTION_INITIATED_LOCAL_REP = 'ACTION_INITIATED_LOCAL_REP';
export const ACTION_COMPLETED_LOCAL_REP = 'ACTION_COMPLETED_LOCAL_REP';
export const IS_NEXT_ACTION_TRANSITION = 'IS_NEXT_ACTION_TRANSITION';
export const TWEET_INITIATED = 'TWEET_INITIATED';
export const LINK_INITIATED = 'LINK_INITIATED';
export const EMAIL_COLLECTED = 'EMAIL_COLLECTED';
export const SUBSCRIBE_SUBMITTING = 'SUBSCRIBE_SUBMITTING';
export const SUBSCRIBE_SUCCESS = 'SUBSCRIBE_SUCCESS';
export const SHARE_DRAWER_VISIBILITY = 'SHARE_DRAWER_VISIBILITY';
export const TEXT_COPIED_TO_CLIPBOARD = 'TEXT_COPIED_TO_CLIPBOARD';
export const SHOW_EMAIL_INTERSTITIAL = 'SHOW_EMAIL_INTERSTITIAL';
export const INCREMENT_NO_CARDS_VISITED = 'INCREMENT_NO_CARDS_VISITED';
export const SET_PARTNER = 'SET_PARTNER';

export const getApiRequestData = (action, state) => {
    if (action == null || state == null) return null;
    return {
        id: action.id,
        actionId: action.actionId,
        articleId: state.widget.apiRequestData.articleId,
        articleUrl: state.widget.apiRequestData.articleUrl,
        widgetId: state.widget.apiRequestData.widgetId,
        partner: action.partner ? action.partner.name : null,
        partnerId: action.partner ? action.partner.id : null,
        publisherId: state.widget.apiRequestData.publisherId,
        clientId: getGoogleAnalyticsClientId(),
        clientIdCustom: clientIdCustom,
        publishedDate: state.widget.apiRequestData.publishedDate,
        widgetType: state.widget.apiRequestData.widgetType,
        widgetEmbedType: state.embedType,
        issueId: action.issue ? action.issue.id : null,
        subIssueId: action.subIssue ? action.subIssue.id : null,
        categoryIds: action.categoryIds ? action.categoryIds : [],
        actionOrder: action.order,
        widgetCardId: action.widgetCardId
    };
};

export const actionShared = sharedWith => dispatch => {
    dispatch({
        type: ACTION_SHARED,
        payload: sharedWith
    });

    return true;
};

export const setOverlayVisible = isVisible => dispatch => {
    dispatch({
        type: OVERLAY_VISIBLE,
        payload: isVisible
    });
};

export const setOverlayPublisherVisible = isPublisherVisible => dispatch => {
    dispatch({
        type: OVERLAY_PUBLISHER_VISIBLE,
        payload: isPublisherVisible
    });
};

export const setOverlayPartnerVisible = (
    isPartnerVisible,
    event,
    isRockTheVote
) => dispatch => {
    if (typeof event !== 'undefined') {
        if (event.target.id === 'partnerName' || isRockTheVote) {
            dispatch({
                type: OVERLAY_PARTNER_VISIBLE,
                payload: isPartnerVisible
            });
        }
    } else {
        dispatch({
            type: OVERLAY_PARTNER_VISIBLE,
            payload: isPartnerVisible
        });
    }

    if (isRockTheVote) {
        dispatch({
            type: OVERLAY_ELECTION_VISIBLE,
            payload: { isRockTheVote: true }
        });
    } else {
        setTimeout(function() {
            dispatch({
                type: OVERLAY_ELECTION_VISIBLE,
                payload: { isRockTheVote: false }
            });
        }, 400);
    }
};

export const widgetVisible = (widgetId, articleUrl) => dispatch => {
    trackWidgetVisible(widgetId, articleUrl);
    onWidgetVisibleSalon();

    dispatch({
        type: WIDGET_VISIBLE
    });
};

export const widgetEngaged = engaged => dispatch => {
    if (!engaged) {
        onEngagement();
        dispatch({
            type: WIDGET_ENGAGED
        });
    }
};

export const resizeWidget = () => dispatch => {
    dispatch({
        type: WIDGET_RESIZED
    });
};

export const loadLocation = () => dispatch => {
    return getGeoIpData().then(data => {
        if (data) {
            dispatch({
                type: SET_END_USER_LOCATION,
                payload: data
            });
        }
    });
};

const closeEverything = (dispatch, isMultiActionsCard) => {
    dispatch({
        type: OVERLAY_PUBLISHER_VISIBLE,
        payload: false
    });

    dispatch({
        type: OVERLAY_PARTNER_VISIBLE,
        payload: false
    });

    dispatch({
        type: OVERLAY_VISIBLE,
        payload: false
    });

    dispatch({
        type: SHARE_DRAWER_VISIBILITY,
        payload: false
    });

    if (isMultiActionsCard) {
        var dataActionVisible = document.querySelectorAll('[data-action]');
        for (var i = 0; i < dataActionVisible.length; i++) {
            dataActionVisible[i].disabled = true;
        }
    }
};

export const onFinishMultiAction = actionIdentifier => dispatch => {
    dispatch({
        type: SET_PARTNER,
        payload: { actionIdentifier, isFrontCard: true }
    });

    dispatch(replace('/multiActionsCard'));
};

export const onGoToNextActionInsideCard = (
    actionIdentifier,
    type,
    isMultiActionsCard
) => dispatch => {
    closeEverything(dispatch, isMultiActionsCard);

    dispatch({
        type: SHOW_NEXT_ACTION_ANIMATION
    });

    dispatch({
        type: IS_NEXT_ACTION_TRANSITION,
        payload: true
    });

    dispatch({
        type: GO_NEXT_ACTION,
        payload: { actionIdentifier }
    });

    dispatch({
        type: SET_PARTNER,
        payload: { actionIdentifier, isFrontCard: false }
    });

    dispatch(replace(`/${type}`));

    setTimeout(function() {
        dispatch({
            type: ACTION_INITIATED_LOCAL_REP,
            payload: actionIdentifier
        });
    }, 1000);
};

export const onGoToNextCard = (
    actionIdentifier,
    type,
    isMultiActionsCard, // refers to next card
    isMultiRepAction, // refers to next card
    skipFrontCardOnNextAction,
    isSameAction // if this transistion doesn't represent a new action (for preloader)
) => dispatch => {
    closeEverything(dispatch, isMultiActionsCard);

    dispatch({
        type: IS_NEXT_ACTION_TRANSITION,
        payload: false
    });

    dispatch({
        type: GO_NEXT_ACTION,
        payload: { actionIdentifier }
    });

    dispatch({
        type: INCREMENT_NO_CARDS_VISITED
    });

    dispatch({
        type: SET_PARTNER,
        payload: { actionIdentifier, isFrontCard: true }
    });

    if (isMultiActionsCard) {
        dispatch(replace(`/multiActionsCard`));
    } else if (isMultiRepAction) {
        dispatch(replace(`/targetedMultiAction`));
    } else if (skipFrontCardOnNextAction) {
        dispatch(replace(`/${type}`));
    } else {
        dispatch(replace(`/${type}/start`));
    }

    setTimeout(function() {
        dispatch({
            type: HIDE_NEXT_ACTION_ANIMATION
        });
        if (!isSameAction) {
            setTimeout(function() {
                dispatch({
                    type: ACTION_VISIBLE
                });
            }, 800);
        }
    }, 800);
};

export const goToRoute = type => dispatch => {
    dispatch(replace(`/${type}`));
};

export const onBackWithinCard = (actionIdentifier, card) => dispatch => {
    dispatch({
        type: SET_PARTNER,
        payload: { actionIdentifier, isFrontCard: true }
    });
    if (card.type === CardTypes.oneAction) {
        const action = card.actions[0];
        dispatch(replace(`/${action.type}/start`));
    } else if (
        card.type === CardTypes.multipleActions ||
        card.type === CardTypes.multiDonation
    ) {
        dispatch(replace(`/multiActionsCard`));
    } else if (card.type === CardTypes.targetedMultiAction) {
        dispatch(replace(`/targetedMultiAction`));
    }

    dispatch({
        type: ON_BACK_FROM_REP_ACTION,
        payload: actionIdentifier
    });
};

export const onSubscribeComplete = (
    values,
    activeActionType,
    collectEmailFor,
    isMultiActionsCard,
    skipNavigatingToSuccessPage = false,
    callback = null
) => dispatch => {
    dispatch({
        type: SUBSCRIBE_SUBMITTING,
        payload: true
    });

    return apiSubscribeEmail(values, collectEmailFor)
        .then(() => {
            setTimeout(function() {
                dispatch({
                    type: EMAIL_COLLECTED,
                    payload: true
                });

                dispatch({
                    type: SUBSCRIBE_SUCCESS,
                    payload: true
                });

                if (typeof callback === 'function') {
                    callback();
                }

                dispatch({
                    type: SUBSCRIBE_SUBMITTING,
                    payload: false
                });

                if (activeActionType) {
                    dispatch({
                        type: SHOW_EMAIL_INTERSTITIAL,
                        payload: false
                    });

                    if (isMultiActionsCard) {
                        dispatch(replace(`/multiActionsCard`));
                    } else if (skipNavigatingToSuccessPage) {
                        if (activeActionType === 'sentimentpoll') {
                            dispatch({ type: SENTIMENT_POLL_ANSWERED });
                        }
                        return;
                    } else if (isMultiActionsCard === false) {
                        dispatch(replace(`/${activeActionType}/success`));
                    }

                    setTimeout(() => {
                        dispatch({
                            type: OVERLAY_VISIBLE,
                            payload: false
                        });
                    }, 3000);
                }
            }, 800);
        })
        .catch(reason => {
            dispatch({
                type: SUBSCRIBE_SUBMITTING,
                payload: false
            });

            throw new SubmissionError({
                _error: reason.message,
                email: "Couldn't submit form, try again later"
            });
        });
};

export const openShareDrawer = () => dispatch => {
    dispatch({
        type: SHARE_DRAWER_VISIBILITY,
        payload: true
    });
};

export const closeShareDrawer = () => dispatch => {
    dispatch({
        type: SHARE_DRAWER_VISIBILITY,
        payload: false
    });
};

export const copyToClipboard = () => dispatch => {
    dispatch({
        type: TEXT_COPIED_TO_CLIPBOARD,
        payload: true
    });
};

export const onShowEmailInterstitial = () => dispatch => {
    dispatch({
        type: SHOW_EMAIL_INTERSTITIAL,
        payload: true
    });
};

export const skipInterstitialPopup = (
    activeActionType,
    isMultiActionsCard,
    skipNavigatingToSuccessPage = false
) => dispatch => {
    setTimeout(() => {
        dispatch({
            type: SHOW_EMAIL_INTERSTITIAL,
            payload: false
        });

        if (isMultiActionsCard) {
            dispatch(replace(`/multiActionsCard`));
        } else if (skipNavigatingToSuccessPage) {
            if (activeActionType === 'sentimentpoll') {
                dispatch({ type: SENTIMENT_POLL_ANSWERED });
            }
        } else {
            dispatch(replace(`/${activeActionType}/success`));
        }
    }, 100);
};



// WEBPACK FOOTER //
// ./src/containers/Widget/actions.js